import { theme } from '_constants/theme';
import styled, { css } from 'styled-components';
import React from 'react';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { colors, devices, fontSizes, spaces } = theme;

const StyledAboutMissionSection = styled.div`
  max-width: ${spaces.large24X * 10 + 80}px;
  display: flex;
  flex-direction: column;
  margin-bottom: ${spaces.large24X}px;
  .headerSection {
    margin-left: ${spaces.regular}px;
    margin-right: ${spaces.regular}px;
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.large11X}px;
    line-height: 130%;
    text-align: center;
    color: ${colors.gray[800]};
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
  }
  @media ${devices.laptopM} {
    padding-left: ${spaces.large2X}px;
    padding-right: ${spaces.large2X}px;
  }
  @media ${devices.tablet} {
    margin-top: ${spaces.large9X}px;
    margin-bottom: ${spaces.large9X}px;
    margin-left: 0px;
    margin-right: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0px;
    flex: none;
    order: 1;
    flex-grow: 0;
    .headerSection {
      font-size: ${fontSizes.large2X}px;
      margin-left: 16px;
      margin-right: 16px;
      line-height: 150%;
    }
  }
`;
const StyledAboutMissionContainer = styled.div`
  display: flex;
  gap: ${spaces.large2X - 2}px;
  margin-top: ${spaces.large2X}px;
  @media ${devices.tablet} {
    gap: 0px;
    flex-direction: column;
    margin-top: ${spaces.smallX}px;
  }
`;
const StyledWhyLeft = styled.div`
  flex-grow: 1;
  width: 50%;
  text-align: right;
  display: flex;
  align-items: flex-end;
  justify-content: end;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 30px;
  img {
    max-width: 100%;
    max-height: 100%;
  }
  .imageContainer {
    width: 36%;
  }
  .imageContainer2 {
    width: 64%;
  }
  @media ${devices.tablet} {
    width: 100%;
    gap: 16px;
    padding-left: 16px;
    padding-right: 16px;
    justify-content: space-between;
    img {
      max-width: 100%;
      max-height: 100%;
    }
    .imageContainer {
      width: 47%;
    }
    .imageContainer2 {
      width: 100%;
    }
  }
`;
const StyledWhyRight = styled.div`
  flex-grow: 1;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  /* Gray/700 */
  color: #344054;
  @media ${devices.tablet} {
    padding-left: 16px;
    padding-right: 16px;
    display: block;
    width: 100%;
    font-size: 16px;
  }
`;
const AboutMissionSection = () => {
  return (
    <StyledAboutMissionSection>
      <div className="headerSection">Our Mission</div>
      <StyledAboutMissionContainer>
        <StyledWhyRight>
          <p>
            Trademark Genius&#39;s mission is to provide small business owners
            with proven, simplified, efficient and competitively affordable
            solutions to protecting their brands and businesses.
          </p>
          <p>
            Our #1 goal is to provide a &quot;One Stop Shop&quot; for business
            and brand protection in one place, all being easily accessible from
            the comfort of your own home. Our top priority and value that
            consistently shows in our services is placing business owners first,
            ensuring they are informed each step of the way and on the fastest
            track to meeting their goals. We strive to aid owners who cannot
            afford a full-service property attorney to avoid missing any
            critical steps associated in Trademark ownership.
          </p>
        </StyledWhyRight>
        <StyledWhyLeft>
          <div className="imageContainer">
            <picture>
              <img
                src={`${publicRuntimeConfig.basePath}/images/aboutMission1.png`}
                alt=""
              />
            </picture>
          </div>
          <div className="imageContainer">
            <picture>
              <img
                src={`${publicRuntimeConfig.basePath}/images/aboutMission2.png`}
                alt=""
              />
            </picture>
          </div>
          <div className="imageContainer2">
            <picture>
              <img
                src={`${publicRuntimeConfig.basePath}/images/aboutMission3.png`}
                alt=""
              />
            </picture>
          </div>
        </StyledWhyLeft>
      </StyledAboutMissionContainer>
    </StyledAboutMissionSection>
  );
};

export default AboutMissionSection;
